import {
    FC,
    ReactElement,
    ChangeEventHandler,
    useCallback,
    useEffect,
    useState,
    KeyboardEventHandler,
} from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import cn from 'classnames';

import './Input.scss';

type InputProps = {
    type?: string;
    placeholder?: string;
    'data-id'?: string;
    icon?: ReactElement;
    style?: {
        [key: string]: any;
    };
    value?: string;
    error?: boolean;
    onChange: ChangeEventHandler<HTMLInputElement>;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
};

const Input: FC<InputProps> = ({
    type = 'text',
    placeholder,
    icon,
    style,
    'data-id': dataId,
    value,
    onChange,
    onKeyDown,
    error,
}) => {
    const [inputType, setInputType] = useState(type);

    const toggleShowPassword = useCallback(
        e => {
            e.persist();
            e.stopPropagation();
            setInputType(prevState => (inputType === 'text' ? 'password' : 'text'));
        },
        [inputType],
    );

    useEffect(() => {
        setInputType(type);
    }, [type]);

    return (
        <div
            className={cn('input-wrapper', {
                'input-wrapper_error': error,
                'input-wrapper_with-icon': !!icon,
            })}
            style={style}
        >
            {icon && <div className="input__icon">{icon}</div>}
            <input
                data-id={dataId}
                className="input"
                value={value}
                type={inputType}
                placeholder={placeholder}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
            {type === 'password' && (
                <div className="input__show-password" onMouseDown={toggleShowPassword}>
                    {inputType === 'password' ? <FaEye /> : <FaEyeSlash />}
                </div>
            )}
        </div>
    );
};

export default Input;
